﻿export interface IRecipientPreferences {
    isWillingToTravel: boolean,
    isIncompatibleAboOkay: boolean,
    incompatibleAboSignOff: string,
    willAcceptShippedKidney: boolean,
    minimumDonorWeight: number,
    maximumDonorAge: number,
    minimumHlaMatchPoints: number,
    requirePreselect: boolean,
    requireEplet: number,
    ebvPreference: number,
    cmvPreference: number
}
